<script setup lang="ts">
import { useConvexAuth } from './composables/useConvexAuth';
import { useUserSettings } from './composables/useUserSettings';

// Initialize auth and settings globally
useConvexAuth();
useUserSettings();
</script>

<template>
  <router-view />
</template>
